export const TYPES = {
  SET_FINANCE_RESELLER_ALL: "finance_reseller/SET_FINANCE_RESELLER_ALL",
  SET_FINANCE_RESELLER_OPEN_ADD:
    "finance_reseller/SET_FINANCE_RESELLER_OPEN_ADD",
  SET_FINANCE_RESELLER_OPEN_EDIT:
    "finance_reseller/SET_FINANCE_RESELLER_OPEN_EDIT",
  SET_FINANCE_RESELLER_SELECTED:
    "finance_reseller/SET_FINANCE_RESELLER_SELECTED",
  SET_FINANCE_RESELLER_SEARCH:
    "finance_reseller/SET_FINANCE_RESELLER_SEARCH",
  SET_FINANCE_RESELLER_DATES: "finance_reseller/SET_FINANCE_RESELLER_DATES",
};
